import { XMarkIcon } from '@heroicons/react/20/solid';

export const SearchPanel = ({ performSearch, keyword, setKeyword, setCurrentPage }) => {

    const handleChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(0);
        performSearch(undefined, 0);
    };

    const handleQueryClear = (e) => {
        setKeyword('');
        e.preventDefault();
        setCurrentPage(0);
        performSearch('', 0);
    }

    return (
        <form onSubmit={handleFormSubmit}>
            <div className="relative flex flex-row items-center w-full bg-white overflow-hidden dark:bg-zinc-700 dark:ring-zinc-700 rounded-2xl text-gray-400 focus-within:text-slate-700 dark:focus-within:text-gray-300 focus-within:ring-2 focus-within:ring-blue-500 transition duration-150 ease-in-out">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" aria-hidden="true" className="text-lg">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"></path>
                    </svg>
                </div>
                <input 
                    className="w-full h-11 pl-10 pr-4 bg-transparent hover:bg-gray-50 dark:hover:bg-zinc-600/30 focus:outline-none focus:ring-0" 
                    type="text" name="search" autoComplete="off" spellCheck="false" placeholder="科目名や教員名などを検索..." 
                    value={keyword} onChange={handleChange}
                />
                {keyword && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center">
                        <button
                            type="button"
                            onClick={handleQueryClear}
                            className="inline-flex items-center rounded-full hover:bg-gray-100 dark:hover:bg-zinc-600/90 p-1.5 font-semibold active:scale-90 transition duration-150 ease-in-out focus:outline-none"
                            aria-label="Clear search queries"
                        >
                            <XMarkIcon className="size-5" />
                        </button>
                    </div>
                )}
            </div>
        </form>
    );
};